module.exports = __webpack_public_path__ + "img/time-redesign.b2f51ae7.svg";